import { FC } from 'react';
import { Stack, Grid, Skeleton } from '@mui/material';

import { BoxWell } from '@shared/components/BoxWell';


export const StoryItemSkeleton: FC = () => {
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
            <BoxWell sx={{ height: 200 }}>
              <Stack spacing={2} alignItems="center" justifyContent="center">
                <Skeleton variant="rounded" width="80%"/>
                <Skeleton variant="rounded" width="80%"/>
                <Skeleton variant="rounded" width="80%"/>
              </Stack>
            </BoxWell>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};
